import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { chunk, isEmpty, times } from 'lodash';

import {
  RecordsWithTimestamp,
  SearchInstanceDto,
  TimestampedRecordWithData,
} from '@app/components';
import { axios } from '@app/utils';
import { IS_TEST_ENV } from '@app/constants';

const BATCH_AMOUNT = IS_TEST_ENV ? 3 : 50;

export const useBatchInstancesFetch = ({
  queryKey,
  list = [],
}: {
  queryKey: string;
  list?: RecordsWithTimestamp[];
}): UseQueryResult<TimestampedRecordWithData[]> => {
  const fetchItems = async () => {
    const listChunks = chunk(list, BATCH_AMOUNT);

    const responses = await Promise.all(
      times(listChunks.length, index =>
        axios.post<SearchInstanceDto[]>(
          '/opac-inventory/instances/batch-enrichment',
          listChunks[index].map(record => record.instanceId)
        )
      )
    );

    return responses.reduce((recordsData, response, chunkIndex) => {
      const currentChunkResponse = response.data;
      const currentViewedRecordsChunk = listChunks[chunkIndex];

      const recordsWithTimestamp = currentViewedRecordsChunk.map(record => ({
        ...currentChunkResponse.find(({ id }) => id === record.instanceId),
        ...record,
      }));

      return [...recordsData, ...recordsWithTimestamp];
    }, []);
  };

  return useQuery(['instancesBatch', queryKey, list], fetchItems, {
    enabled: !isEmpty(list),
  });
};
